import { Navigate } from "react-router-dom";
export default function BillingSubscribe() {
  return <Navigate to="/settings?section=billing" replace />;
}
